import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as CookieConsent from 'vanilla-cookieconsent';
import { isMatomoConfigured, trackMatomoPageView } from '../lib/matomo';

const ADMIN_PATH = '/admin-secret-wownautic-2024';

/**
 * Envoie une page vue Matomo à chaque navigation (SPA), si analytics accepté.
 */
const MatomoAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!isMatomoConfigured()) return;
    if (location.pathname.startsWith(ADMIN_PATH)) return;
    if (!CookieConsent.acceptedCategory('analytics')) return;

    trackMatomoPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default MatomoAnalytics;
